import React from 'react';
import { TreeSelect } from 'antd';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
  PCT_AVAILABLE_WATER,
  RAINFALL,
  ROOT_ZONE_VWC,
  SOIL_MOISTURE_ALL_DEPTHS,
  SOIL_TEMPERATURE,
  VALVE_STATE,
  WATER_PRESSURE,
  TEMPERATURE,
  HUMIDITY,
} from '../hooks/graph';
import { DEFAULT_SOIL_CHARTS } from './presetChartDefaults';

const { SHOW_PARENT } = TreeSelect;

const SoilPresetChartSelect = ({onSelectChange, value}) => {
  const { t } = useTranslation();

  const treeData = [
    {
      title: t('Root Zone Moisture'),
      value: ROOT_ZONE_VWC,
      key: ROOT_ZONE_VWC,
    },
    {
      title: t('Percent Available Water'),
      value: PCT_AVAILABLE_WATER,
      key: PCT_AVAILABLE_WATER,
    },
    {
      title: t('Moisture All Depths'),
      value: SOIL_MOISTURE_ALL_DEPTHS,
      key: SOIL_MOISTURE_ALL_DEPTHS,
    },
    {
      title: t('Soil Temperature'),
      value: SOIL_TEMPERATURE,
      key: SOIL_TEMPERATURE,
    },
    {
      title: t('Water Pressure'),
      value: WATER_PRESSURE,
      key: WATER_PRESSURE,
    },
    {
      title: t('Rainfall'),
      value: RAINFALL,
      key: RAINFALL,
    },
    {
      title: t('Valve State'),
      value: VALVE_STATE,
      key: VALVE_STATE,
    },
    {
      title: t('Temperature'),
      value: TEMPERATURE,
      key: TEMPERATURE,
    },
    {
      title: t('Humidity'),
      value: HUMIDITY,
      key: HUMIDITY,
    },
  ];

  const onChange = (newValue) => {
    onSelectChange(newValue);
  };

  const tProps = {
    treeData,
    value,
    onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: t('Charts'),
    className: 'soil-preset-chart-select',
    dropdownStyle: isMobile?{
      position: 'fixed',
      height: '100%',
      padding: '20px'
    }:{},
    getPopupContainer: () => document.getElementById('soilPresetChartSelect'),
  };

  return (
    <div id="soilPresetChartSelect">
      <TreeSelect {...tProps} />
    </div>

  );
};

SoilPresetChartSelect.propTypes = {
  onSelectChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
};

SoilPresetChartSelect.defaultProps = {
  onSelectChange: () => null,
  value: DEFAULT_SOIL_CHARTS,
};

export default SoilPresetChartSelect;
